module.exports = __webpack_public_path__ + "img/warbling-vireo.c56336ba.jpg";